module.exports = __webpack_public_path__ + "static/media/school-profile-banner2.a62d6d10.png";